import { createContext } from "react"
import { Tabs } from "accounts/domain"

export interface SignInContextType {
  isSignInModalOpen: boolean
  openSignInModal: (tab?: Tabs) => void
  closeSignInModal: () => void
  nextLocation?: string
  setNextLocation: (path: string) => void
  initialTab: Tabs
}

const SignInContext = createContext<SignInContextType>({
  isSignInModalOpen: false,
  openSignInModal: () => {},
  closeSignInModal: () => {},
  nextLocation: undefined,
  setNextLocation: () => {},
  initialTab: Tabs.SignIn
})

export default SignInContext
